import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "store-locator-page d-flex" }
const _hoisted_2 = { class: "store-filters-height col-12 col-md-4 no-col-padding" }
const _hoisted_3 = { class: "store-locator-height col-12 col-md-8 no-col-padding" }
const _hoisted_4 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StoreLocatorFilters = _resolveComponent("StoreLocatorFilters")!
  const _component_StoreLocatorMap = _resolveComponent("StoreLocatorMap")!
  const _component_BecomeDealerButton = _resolveComponent("BecomeDealerButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_StoreLocatorFilters)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_StoreLocatorMap)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_BecomeDealerButton)
    ])
  ]))
}